// src/pages/agent/Contracts.js
// Library of contract templates the agent can fill from a lead.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PageHeader, Card, Btn, BORDER, BURG_DK, MID, LIGHT } from '../../components/agent/UI';

const TEMPLATES = [
  { id: 'psa',          label: 'Purchase & Sale Agreement',           desc: 'Use when locking up a property under contract with the seller.' },
  { id: 'assignment',   label: 'Assignment of Contract of Sale',      desc: 'Assign your PSA position to a cash buyer for an assignment fee.' },
  { id: 'novation',     label: 'Authorization to Sign Listing Docs',  desc: 'Limited power of attorney granting authority to list and execute docs on the seller\'s behalf.' },
  { id: 'cancellation', label: 'Cancellation of Purchase & Sale',     desc: 'Mutually cancel an existing PSA, releasing all parties.' },
  { id: 'jv',           label: 'Real Estate Joint Venture Agreement', desc: 'Split an assignment fee with a JV partner on a specific deal.' }
];

export default function Contracts() {
  const navigate = useNavigate();
  return (
    <>
      <PageHeader
        eyebrow="E-signature"
        title="Contract templates"
        sub="All five templates are baked into the platform, fully branded, and ready to merge with any lead. Open any lead's Contracts panel to fill and send — or click Preview to see exactly what the signer will receive."
      />
      <div style={s.grid}>
        {TEMPLATES.map(t => (
          <Card key={t.id} title={t.label}>
            <div style={{ fontSize: 13, color: MID, lineHeight: 1.55, minHeight: 60 }}>{t.desc}</div>
            <div style={{ marginTop: 14, fontSize: 11, color: LIGHT, marginBottom: 14 }}>
              Auto-filled from the lead: parties, subject property, purchase price, dates.
            </div>
            <Btn variant="ghost" onClick={() => navigate(`/agent/contracts/preview/${t.id}`)}>
              Preview →
            </Btn>
          </Card>
        ))}
      </div>

      <button onClick={() => navigate('/agent/leads')} style={s.cta}>← Back to leads</button>
    </>
  );
}

const s = {
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 16, marginBottom: 16 },
  cta: { background: 'transparent', border: `1px solid ${BORDER}`, color: BURG_DK, padding: '8px 16px', fontSize: 12, borderRadius: 4, cursor: 'pointer', fontFamily: "'DM Sans', sans-serif" }
};
